import { NgModule } from '@angular/core';
import { OccPaymentsNormalizer, PAYMENTS_NORMALIZER } from './occ-payments-normalizer';

@NgModule({
  providers: [
    {
      provide: PAYMENTS_NORMALIZER,
      useClass: OccPaymentsNormalizer,
      multi: true,
    },
  ],
})
export class PaymentsConvertersModule {}
